module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('coming-soon-modal', {
    attrs: {
      "dialog": _vm.dialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), (_vm.show) ? _c('v-bottom-nav', {
    staticClass: "bottomNavbar",
    attrs: {
      "active": _vm.bottomNav,
      "value": true
    },
    on: {
      "update:active": function($event) {
        _vm.bottomNav = $event
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "value": "dashboard"
    },
    on: {
      "click": function($event) {
        return _vm.replace('/dashboard')
      }
    }
  }, [_c('span', [_vm._v("Inicio")]), _vm._v(" "), _c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "value": "equipments"
    },
    on: {
      "click": function($event) {
        return _vm.replace('/equipments')
      }
    }
  }, [_c('span', [_vm._v("Equipos")]), _vm._v(" "), _c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-bottom-sheet', {
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "color": "primary",
      "value": "mas"
    },
    on: {
      "click": function($event) {
        return _vm.trackMas()
      }
    },
    slot: "activator"
  }, [_c('span', [_vm._v("Mas")]), _vm._v(" "), _c('v-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.selectedSettings()
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    }
  }, [_c('v-icon', [_vm._v("settings")])], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Ajustes")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.commignsoon('/historics')
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    }
  }, [_c('v-icon', [_vm._v("history")])], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Históricos")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.onLogout()
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-avatar', {
    attrs: {
      "size": "32px",
      "tile": ""
    }
  }, [_c('v-icon', [_vm._v("exit_to_app")])], 1)], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Cerrar sesión")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b83af438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/BottomNav.vue
// module id = 782
// module chunks = 22